import axios from "axios";
import Paths from "../utils/paths";

const axiosInstance = axios.create({
  baseURL: `${Paths.BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
